import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "./Reveal";

export default function Chapter({ index, kicker, title, paragraphs, image, flip }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-7%", "7%"]);

  return (
    <section ref={ref} className="relative py-20 md:py-28 overflow-hidden">
      <div className="max-w-screen-2xl mx-auto px-6 grid md:grid-cols-12 gap-8 md:gap-10 items-center">
        <Reveal className={`md:col-span-3 ${flip ? "md:order-3" : ""}`}>
          <span className="outline-text font-display font-light leading-none text-[26vw] md:text-[10vw] block">
            {index}
          </span>
        </Reveal>
        <Reveal delay={0.12} className={`md:col-span-4 ${flip ? "md:order-2" : ""}`}>
          <p className="text-[11px] uppercase tracking-[0.35em] text-primary mb-5">{kicker}</p>
          <h3 className="font-display font-light text-4xl lg:text-5xl leading-tight mb-6">{title}</h3>
          {paragraphs.map((p, i) => (
            <p key={i} className="text-muted-foreground leading-relaxed text-sm md:text-base mb-4 last:mb-0">
              {p}
            </p>
          ))}
        </Reveal>
        <Reveal delay={0.22} className={`md:col-span-5 ${flip ? "md:order-1" : ""}`}>
          <div className="relative overflow-hidden h-[300px] md:h-[460px]">
            <motion.img
              src={image}
              alt={title}
              style={{ y }}
              className="absolute -top-[10%] left-0 w-full h-[120%] object-cover"
            />
            <div className="absolute inset-0 bg-black/20" />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
